Vue.component('fileuploadform', {
  data() {
    return {

    };
  },
});
